const en = {
    //need to edit some of contents

    common: {
        app_name: 'PAI',

        save: 'Save',
        reset: 'Reset',
        id: 'ID',
        description: 'Description',
        ok: 'Ok',
        cancel: 'Cancel',
        yes: 'Yes',
        no: 'No',
        next: 'Next',
        previous: 'Previous',
        search: 'Search',
        delete: 'Delete',

        confirm_delete_title: 'Confirm Delete',
        confirm_delete_message: 'Are you sure you want to delete',

        profile: 'Profile',
        logout: 'Logout',
        none: 'None',
        select: 'select',
        all: 'All',

        side_menu: {
            route_mgmt: 'Route Management',
            route_control: 'Route Control',
            route_throw: 'Route Throw',
            check_in: 'Check In',
            check_out: 'Check Out',
            bag_out: 'Bag Out',
            settings: 'Settings',
            route_sheet: 'Route Sheet',
            route_release: 'Route Release',
            shipment_batch: 'Shipment Batch',
            coin_pull_report: 'Coin Pull Report',
            setup: 'Setup'
        }
    },
    home: {

    },
    routeSheet: {
        route: 'Route ',
        date: 'Date',
        show: 'Show',
        print: "Print",

        routePlaceHolder: 'Select a route...'
    },
    routeControl: {
        adHocCheckinNoUnassignedRoute: 'No unassigned route found for this branch. Please configure an Unassigned Route in Setup.',
        adHocCheckinTitle: 'Ad-Hoc Check-In | ',
        checkInAction: 'Check In'
    },
    login: {
        button: 'Login',
        remember_me: 'Remember Me',
        remember_me_message: 'Do not enable this option if you are on a public computer.',
        email: 'Email',
        password: 'Password',
        
        forgot_password: 'Forgot Password?',
        change_password: 'Change Password?',
        email_placeholder: 'Your e-mail or user name',
        password_placeholder: 'Your password',
        
        forgot_email_placeholder: 'Enter your e-mail',
        code: 'Code',
        reset_code_placeholder: 'Enter Code',
        password_placeholder: 'Enter password',
        confirm_password: 'Confirm Password',
        confirm_password_placeholder: 'Enter confirm password',
        reset_request_success: 'Password reset successfully, Please try to login now!',
        forgot_password_label: 'Forgot Password',
        change_password_label: 'Change Password',
        reset_password_label: 'Change/Reset Password',
        reset_password_request_code: 'Your forgot password code shared on the registered email address. Please check your inbox',
        force_change_password_message: 'You need to update your password. your password has expired. password will expire every',
        password_policy_criteria_message: 'Your current password does not satisfy the password policy criteria. Please reset your password to continue.',
        duplicate_password_warning: 'Your new password should not be same as your current password.',
        resend_code: 'Resend code',
        login_2FA__code_placeholder: 'Enter the 6-digit code sent to your email to complete the login process.'
    },
    batch: {
        menu: {
            title: 'Batches',
            create: 'New Batch',
            all: 'All Batches'
        },

        batches: 'Batches',
        all_batches: 'All Batches',
        create_batch: 'New Batch',
        edit_batch: 'Edit Batch',
        inputType: 'Input Type',
        batchSourceId: 'Batch Source ID',
        tooltip_delete: 'Delete Batch',
        tooltip_edit: 'Edit Batch',
        tooltip_reload: 'Refresh',
        tooltip_del: 'Delete',
        create_another_title: 'Create Batch',
        create_another_message: 'Do you want to create another Batch?',
        location: 'Location',
        tooltip_info : 'Show data of location type INTERNAL and BANK',
        noBatches: 'No Batches Found'
    },
    users: {
        menu: {
            title: 'Users',
            create: 'New User',
            all: 'All Users'
        },
        branchId: 'Branch',
        role: 'Roles',
        permission: 'Permissions',
        users: 'User',
        all_users: 'All Users',
        create_users: 'New User',
        edit_users: 'Edit User',
        name: 'Name',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        languageId: 'Language',
        supervisor: 'Supervisor',
        user: 'User',
        password: 'Password',
        cnfpassword: 'Confirm Password',
        E: 'English',
        F: 'French',
        S: 'Spenish',
        handheldUser: 'Handheld User',
        webUser: 'Web User',
        tooltip_delete: 'Delete User',
        tooltip_edit: 'Edit User',
        tooltip_reload: 'Refresh',
        confirm_password_error : "password mismatch",
        create_another_title: 'Create User',
        create_another_message: 'Do you want to create another User?',
        noUsers: 'No Users Found'
    },
    route: {
        menu: {
            title: 'Routes',
            create: 'New Route',
            all: 'All Routes'
        },

        route: 'Route',
        name: 'Name',
        shortName: 'Short Name',
        loadTruck: 'Load Truck',
        holdRoute: 'Hold Route',
        beginTime: 'Begin Time',
        branchId: 'Branch',
        all_routes: 'Routes',
        tag: 'Delivery Routes used by Ranger American',

        create_route: 'New Route',
        edit_route: 'Edit Route',

        tooltip_delete: 'Delete Route',
        tooltip_edit: 'Edit Route',
        tooltip_reload: 'Refresh',

        create_another_title: 'Create Route',
        create_another_message: 'Do you want to create another Route?',

        routeSequence: 'Route Sequence',
        noRouteSequenceLocation: 'No Location is using this route on',

        noRoutes: 'No Routes Found'
    },
    shiptype: {
        menu: {
            title: 'Shiptypes',
            create: 'New Shiptype',
            all: 'All Shiptypes'
        },
        status: 'Status',
        shiptype: 'Shiptype',
        all_shiptype: 'All Shiptypes',
        create_shiptype: 'New Shiptypes',
        edit_shiptype: 'Edit Shiptypes',
        id: 'Ship Type ID',
        description: 'Description',
        unitValue: 'Unit Value',
        coin: 'Coin',
        useAmount: 'Use Amount',
        amount: 'Amount',
        handheld: 'Handheld',
        batchDisplay: 'Batch Display',
        shipmentID: 'Shipment IDs',
        tooltip_delete: 'Delete Shiptype',
        tooltip_edit: 'Edit Shiptype',
        tooltip_reload: 'Refresh',

        suspend_shiptype: 'Confirm',
        suspend_shiptype_message: 'Are you sure you want to make this Shipment in In-Active ?',
        create_another_title: 'Create Shiptype',
        create_another_message: 'Do you want to create another Shiptype ?',

        noShiptypes: 'No Shiptypes Found',
        sortOrder: 'Sort Order'
    },
    location: {
        menu: {
            title: 'Locations',
            create: 'New Location',
            all: 'All Locations'
        },

        location: 'Location Name',
        id: 'Location ID',
        name: 'Name',
        all_locations: 'All Locations',
        create_location: 'New Location',
        edit_location: 'Edit Location',

        tooltip_delete: 'Delete Location',
        tooltip_edit: 'Edit Location',
        tooltip_reload: 'Refresh',

        suspend_location: 'Confirm',
        suspend_location_message: 'Are you sure you want to Suspend this Location ?',
        create_another_title: 'Create Location',
        create_another_message: 'Do you want to create another Location?',
        status: 'Status',
        customer: 'Customer',
        branch: 'Branch',
        _address: 'Location Address',
        _city: 'Location City',
        _state: 'Location State',
        _zip: 'Location Zip',
        refId: 'Reference ID',
        _poc: 'Location POC',
        pocPhone: 'POC Phone',
        pocEmail: 'POC Email',
        deliveries: 'Deliveries',
        pickups: 'Pickups',
        day: {
            routeId: 'Route ID',
            stops: 'Stops',
            options: 'Options'
        },
        seasonStart: 'Season Start',
        seasonEnd: 'Season End',
        startTime: 'Start Time',
        endTime: 'End Time',
        locationType: 'Location Type',
        keyId: 'Key ID',
        maxDepositAmount: 'Max Deposit Amount ($0 = no limit)',
        roundedDeposits: 'Rounded Deposits',
        codAllow: 'COD Allowed',
        allowMulti: 'Multi-Stop Allowed',
        individualBagout: 'Individual Bagout',
        deliveryLoc1: '1st Delivery Option',
        deliveryLoc2: '2nd Delivery Option',
        deliveryLocCoin: 'Coin Delivery',
        deliveryLocCod: 'COD Delivery',
        lastTransaction: 'Last Transaction',
        _leave: 'Location Leave',
        atmCassette: 'ATM Cassette',
        maxCassettes: 'Max Cassettes',
        TRdeliveries: 'Deliveries',
        TRpickups: 'Pickups',
        latitude: 'Lattitude',
        longitude: 'Longitude',
        general: 'General',
        routeNotification: 'Route Notification',
        routeAssignment: 'Route Assignment',
        deliveryBackoutTimes: 'Delivery Backout Times',
        deliveryLocations: 'Delivery Locations',
        routeOptions: 'Route Options',
        transactionRequirements: 'Transaction Requirements',
        sameForAll: 'Same For All',
        _type: 'Location Type',
        transactionRequirments: 'Transaction Requirments',
        scan: 'Scan',
        receipts: 'Receipts',
        GPSlocation: 'GPS Location',
        mon: 'Monday',
        tues: 'Tuesday',
        wed: 'Wednesday',
        thurs: 'Thursday',
        fri: 'Friday',
        sat: 'Saturday',
        sun: 'Sunday',
        hol: 'Holiday',
        contract: 'Contract',
        weekday: 'Weekday',
        route: 'Route',
        stop: 'Stop (before)',
        when: 'Frequency',
        scan_bagout_pieces: 'Scan Bagout Pieces',
        packCoinSeparately: 'Pack Coin Separately',
        tooltip_info : 'Enable only for location type INTERNAL and TRUCK',
        noLocations: 'No Locations Found'
    },
    carrier: {
        menu: {
            title: 'Carriers',
            create: 'New Carrier',
            all: 'All Carriers'
        },
        name: 'Carrier Name',
        POCEmail: 'POC Email',
        POCPhone: 'POC Phone',
        POCName: 'POC Name',
        carrier: 'Carrier',
        all_carriers: 'All Carriers',
        create_carrier: 'New Carrier',
        edit_carrier: 'Edit Carrier',

        tooltip_delete: 'Delete Carrier',
        tooltip_edit: 'Edit Carrier',
        tooltip_reload: 'Refresh',

        create_another_title: 'Create Carrier',
        create_another_message: 'Do you want to create another Carrier?',

        noCarriers: 'No Carriers Found'
    },
    message: {
        menu: {
            title: 'Messages',
            create: 'New Message',
            all: 'All Messagees'
        },
        all: 'All',
        types: {
            M: 'Message',
            T: 'Field Tag',
            R: 'Refusal / No Pickup',
            SM: 'Shipment Missing',
            NP: 'No Pickup',
            UI: 'UI'
        },

        messages: 'Messages',
        all_messages: 'All Messages',
        create_message: 'New Message',
        edit_message: 'Edit Message',

        tooltip_delete: 'Delete Message',
        tooltip_edit: 'Edit Message',
        tooltip_reload: 'Refresh',

        create_another_title: 'Create Message',
        create_another_message: 'Do you want to create another Message?',

        messageId: 'Message Id',
        type: 'Type',
        descriptionIn: 'Description In',

        noMessages: 'No Messages Found'
    },
    item: {
        menu: {
            title: 'Items',
            create: 'New Item',
            all: 'All Items'
        },

        items: 'Items',
        all_items: 'All Items',
        create_item: 'New Item',
        edit_item: 'Edit Item',

        tooltip_delete: 'Delete Item',
        tooltip_edit: 'Edit Item',
        tooltip_reload: 'Refresh',

        create_another_title: 'Create Item',
        create_another_message: 'Do you want to create another Item?',

        name: 'Name',
        type: 'Type',
        location: 'Location',
        noItems: 'No Items Found'
    },
    branch: {
        menu: {
            title: 'Branches',
            create: 'New Branch',
            all: 'All Branches'
        },

        branches: 'Branches',
        all_branches: 'All Branches',
        create_branch: 'New Branch',
        edit_branch: 'Edit Branch',

        tooltip_delete: 'Delete Branch',
        tooltip_edit: 'Edit Branch',
        tooltip_reload: 'Refresh',

        create_another_title: 'Create Branch',
        create_another_message: 'Do you want to create another Branch?',
        windows: 'Windows',
        tooltip_window_delete: 'Delete Window',
        tooltip_window_save: 'Save Window',
        confirm: 'Confirm',
        confirm_delete_message: 'Are you sure you want to delete this Window ?',

        noBranches: 'No Branches Found'
    },
    vault: {
        menu: {
            title: 'Vaults',
            create: 'New Vault',
            all: 'All Vaults'
        },

        vaults: 'Vaults',
        all_vaults: 'All Vaults',
        create_vault: 'New Vault',
        edit_vault: 'Edit Vault',

        tooltip_delete: 'Delete Vault',
        tooltip_edit: 'Edit Vault',
        tooltip_reload: 'Refresh',

        create_another_title: 'Create Vault',
        create_another_message: 'Do you want to create another Vault?'
    },
    customer: {
        menu: {
            title: 'Customers',
            create: 'New Customer',
            all: 'All Customers'
        },

        name: 'Name',
        contact: 'Contact',
        accountingId: 'Accounting ID',
        delete_title: 'Delete Contract',
        delete_message: 'Do you want to delete this contract?',
        customers: 'Customers',
        all_customers: 'All Customers',
        create_customer: 'New Customer',
        edit_customer: 'Edit Customer',

        tooltip_delete: 'Delete Customer',
        tooltip_edit: 'Edit Customer',
        tooltip_reload: 'Refresh',
        tooltip_delete_contract: 'Delete Contract',
        create_another_title: 'Create Customer',
        create_another_message: 'Do you want to create another Customer?',
        suspend_customer: 'Confirm',
        suspend_customer_message: 'Are you sure you want to Suspend this Customer ?',

        status: 'Status',
        billing: 'Billing',
        address: 'Address',
        city: 'City',
        state: 'State',
        zip: 'Zip',
        POC: 'POC',
        phone: 'Phone',
        email: 'Email',
        contracts: 'Contracts',

        billToContract: 'Bill To Contract',
        billToCustomer: 'Bill To Customer',
        transport: 'Transport',
        deposit: 'Deposit',
        changeOrder: 'Change Order',
        serviceSchedule: 'Service Schedule',
        contractOverrides: 'Contract Overrides',
        startDate: 'Start Date',
        endDate: 'End Date',
        orderBasis: 'Order Basis',
        orderRate: 'Order Rate',
        standardCoins: 'Standard Coins',
        serviceOption: 'Service Option',
        unitBasis: 'Unit Basis',
        unitRate: 'Unit Rate',
        billToCategory: 'Bill To Category',
        actions: 'Actions',
        contractDetails : 'Contract Details',
        noCustomers: 'No Customers Found'
    },

    truck: {
        menu: {
            title: 'Trucks',
            create: 'New Truck',
            all: 'All Trucks'
        },
        make: 'Make',
        model: 'Model',
        year: 'Year',
        vinnum: 'VIN Number',
        platenum: 'Plate Number',
        trucks: 'Trucks',
        all_trucks: 'All Trucks',
        create_truck: 'New Truck',
        edit_truck: 'Edit Truck',

        tooltip_delete: 'Delete Truck',
        tooltip_edit: 'Edit Truck',
        tooltip_reload: 'Refresh',

        create_another_title: 'Create Truck',
        create_another_message: 'Do you want to create another Truck?',
        suspend_truck: 'Confirm',
        suspend_truck_message: 'Are you sure you want to Suspend this Truck ?',
        tooltip_info : 'Show data of location type TRUCK',
        noTrucks: 'No Trucks Found'
    },

    checkin: {
        title: 'Check In',

        waitForMessenger: 'Waiting on Messenger ID Scan',
        waitForRoute: 'Waiting on Route Scan',
        waitForWindow: 'Waiting on Window ID Scan',

        successfullyCheckedin: 'Successfully Checked In',
        successfullySaved: 'Shipment Changes Saved',

        branch: 'Branch',
        route: 'Route',
        window: 'Window',
        truck: 'Truck',
        force_close: 'Force Close',
        close_route: 'Close Route',
        override: 'Override',
        save_override: 'Save Override',

        remainingItems: 'Remaining Items',

        item: 'Item',
        customer: 'Customer',
        location: 'From',
        type: 'Type',
        amount: 'Amount',
        quantity: 'Quantity',
        destination: 'Destination',
        scan: 'Scan',

        checkedin: 'Checked In',
        putOnHold: 'Item successfully put on hold',
        shipper: 'Shipper'
    },
    checkout: {
        selectRoute: 'Select Route',
        waitForRoute: 'Wait For Route',
        waitForFromTanker: 'Wait for From Tanker Scan',
        waitForToTanker: 'Wait for To Tanker Scan',
    },
    contract: {
        menu: {
            title: 'Contracts',
            create: 'New Contract',
            all: 'All Contracts'
        },
        all_contracts: 'All Contracts',
        edit_contract: 'Edit Contract',
        billToCategory: 'Bill to Category',
        billToInformation: 'Bill To Information',
        contact: 'Contact',
        changeOrder: 'Change Order',
        deposits: 'Deposits',
        transport: 'Transport',

        contractDetails: 'Contact Details',
        contractId: 'Contract ID',
        contractName: 'Contract Name',
        contractCustomer: 'Customer',
        contractStatus: 'Contract Status',

        contractStartDate: 'Start Date',
        contractEndDate: 'End Date',
        contract: 'Contract',
        serviceSchedule: 'Service Schedule',
        orderBasis: 'Order Basis',
        orderRate: 'Order Rate',

        seasonStartDate: 'Season Start',
        seasonEndDate: 'Season End',

        holidayService: 'Holiday Service',
        standardCoins: 'Standard Coin',

        serviceOption: 'Service Option',
        unitBasis: 'Unit Basis',
        unitRate: 'Unit Rate',
        actions: 'Actions',

        tooltip_delete: 'Delete Contract',
        tooltip_edit: 'Edit Contract',
        tooltip_reload: 'Refresh',
        create_another_title: 'Create Contract',
        create_another_message: 'Do you want to create another Contract?',

        noContracts: 'No Contracts Found'
    },
    shipmentBatch: {
        refId: 'RefId',
        currency: 'Currency',
        tracking_id: 'Tracking Id',
        description: 'Description/Notes',
        action: 'Action',
        add: 'Add',
        total: 'Total',
        commit: 'Commit',
        batch_master: 'Batch Master',
        customer: 'Customer',
        pickupDate: 'Pickup Date',
        deliveryDate: 'Delivery Date',
        tooltip_del: 'Delete',
        route: 'Route',
        location: 'From Location',
        reset: 'Reset',

        delete_message: 'Do you Want to Remove This Shipment?',
        invalidLocationMessage: 'RefId has no associated Location',

        alertModalTitle: 'Invalid Operation',
        alertModalMessage: 'Batch should have at least one shipment',

        locationPlaceholder: 'Select a location...',
        tooltip_info : 'Show data of location type INTERNAL and BANK',
        uploadedFiles: 'Files'
    },
    routeControl: {
        menu: {
            title: 'Route Control'
        },
        release: 'Release Route',
        route: 'Route',
        printRoute: 'Route',
        printCoin: 'Coin',

        branch: 'Branch',
        routeDate: 'Route Date',
        all: 'All',
        stops: 'Stops',
        shipments: 'Shipments',
        totalCash: 'Total Cash',
        controls: 'Controls',
        lastReleased: 'Last Released',

        branchPlaceholder: 'Select a Branch...',

        getRoutes: 'Refresh',
        noRoutesFound: 'No Routes Found',

        routeReleasedSuccessfully: 'Route {{routeName}} released successfully.',
        routeReleaseFailed: 'Error occurred while releasing route {{routeName}}.',
        routesReleasedSuccessfully: 'Routes released successfully.',
        routesReleaseFailed: 'Error occurred while releasing routes.'
    },
    routeThrow: {
        title: 'Route Shipments',

        waitForTanker: 'Wait for Tanker Scan',

        item: 'Item',
        end: 'End',
        clear: 'Clear',
        fromTanker: 'From Tanker',
        contents: 'Contents'
    },
    coinPullReport: {
        route: 'Route',
        title: 'Coin Pull Report',
        date: 'Date',
        show: 'Show',
        print: 'Print',
        coin: 'Coin',
        total: 'Total',
        noDesitnationFound: "No destinations found",

        routePlaceHolder: 'Select a Route...'
    },
    holiday: {
        menu: {
            title: 'Holidays'
        },

        addHoliday: 'Add Holiday',
        createHoliday: 'Create Holiday',
        editHoliday: 'Edit Holiday',
        branch: 'Branch',
        startDate: 'Start Date',
        endDate: 'End Date',
        title: 'Title',
        name: 'Name'
    },
    checkinSelectionModal: {
        title: 'Bag Not Found | Possible Alternatives',
        forceBag: 'Add Item',
        select: 'Select'
    },
    confirmSupervisorModal: {
        title: 'Scan Supervisor',
        password: 'Supervisor Password',
        idMissing: 'Supervisor ID can\'t be empty',
        passwordMissing: 'Supervisor Password can\'t be empty',
        supervisor: 'Supervisor ID'
    },
    addBagModal: {
        title: 'Add Item | ',
        trackingId: 'Tracking ID',
        scanSupervisor: 'Scan Supervisor',

        fromLocation: 'From Location',
        all: 'All',
        search: 'Search',
        destination: 'Destination',

        quantity: 'Quantity',
        shiptype: 'Ship Type',
        amount: 'Amount',

        requiredFieldsError: 'Please fill all required fields',
        divisibleByDenomError: 'Amount should be divisible by denomination face value',
        addItem: 'Add Item',
        bagSeal: 'Bag Seal',
        carrier: 'Carrier',
        batch: 'Batch',
        pleaseSelect: 'Please Select'
    },
    forceCheckinModal: {
        title: 'Bag Not On Route',
        forceCheckin: 'Force Checkin'
    },
    closeRouteModal: {
        title: 'Close Route',
        bag: 'Bag',
        pickupLocation: 'Pickup Location',
        locationType: 'Location Type',
        reasonCode: 'Reason Code'
    },
    selectDeliveryLocationModal: {
        title: 'Select Delivery Location'
    },
    routeVerifyResultModal: {
        title: 'Route Verify Result'
    },
    forceCLoseRouteModal: {
        title: 'Force Close Checkin',
        saveAndClose: 'Save & Close',
        not_checked_in: "Not Checked In",
        not_checked_out: "Not Checked Out",
        not_delivered: "Not Delivered",
        not_picked: "Not Picked Up",
        n_a: "N/A",
        please_select: "Select Reason"
    },
    itemNotDeliveredModal: {
        title: 'Item Not Delivered',
        pleaseSelect: 'Please Select'
    },
    closeBagoutModal: {
        bagoutClosed: 'Bagout {{bagout.id}} closed successfully',
        view: 'View'
    },
    commitSuccessModal: {
        title: 'Success',
        message: 'Batch Successfully Committed',
        total: 'Total'
    },
    bagout: {
        title: 'Bag Out',

        waitForBag: 'Waiting for Bagout Seal Scan',
        lastScan: 'Last Scan',

        wrongDestination: 'Wrong Destination',
        addedToBagout: 'Added to Bagout',
        bagNotFound: 'Not Found',
        mismatchDestination: 'Mismatch Destination',
        bagAlreadyAdded: 'Already Scanned',
        previouslyAdded: 'Previously Added',
        shipmentNotCheckedIn: 'Shipment Not Checked In',
        notCheckedIn: 'Not Checked In',
        onhold: 'On Hold',
        shipmentOnHold: 'Item is on Hold',

        branch: 'Branch',
        bagoutSeal: 'Bagout Seal',
        route: 'Route',
        closePrint: 'Close & Print',
        deliveryDate: 'Delivery Date',
        item: 'Item',
        destination: 'Destination',
        location: 'Location',
        amount: 'Amount',
        type: 'Type',
        customer: 'Customer',
        fromCustomer: 'From Customer',
        fromLocation: 'From Location',
        toLocation: 'To Location',
        trackingId: 'Tracking ID',

        //print view
        from: 'From',
        fromLocationName: 'From Location Name',
        fromLocationId: 'From Location ID',
        goToBagout: 'Return To Bagout',
        closeBagout: 'Close Bagout',
        bagoutClosed: 'Bagout Closed',
        confirmCloseBagoutTitle: 'Confirm Bagout Close',
        confirmCloseBagoutMessage: 'Are you sure you want to close bagout',
        totalBags: 'Total Bags',
        totalAmount: 'Total Amount',
        verify: 'Verify',

        success: 'Success',
        fail: 'Fail',
        bagout: 'Bagout',
        totalItems: 'Total Items',
        added: 'added',
        delivery: 'Delivery'
    },
    errorModal: {
        title: 'Error'
    },
    uploadedFileSelectionModal: {
        title: 'Uploaded File Selection',

        fromLocation: "From Location",
        file: 'File',
        carrier: 'Carrier',
        totalAmount: 'Total Amount',
        totalBags: 'Total Bags',
        deliveryDate: 'Delivery Date',
        arrivalDate: 'Arrival Date',
        load: 'Load',

        fileLockMessage: "If you load the file and don't commit the changes, the file will be locked for minimum of 15 minutes before it can be accessed again",

        pickupDateError: 'Selected file has an invalid pickup date',
        deliveryDateError: 'Selected file has delivery date earlier than pickup date'
    },
    error: {
        8000: 'Invalid XML content found',

        90000: 'Invalid Vault Date passed',
        90001: 'Invalid Route ID',
        90002: 'Invalid Route ID',

        90100: 'Invalid Route ID',
        90101: 'Invalid Vault Date',
        90102: 'Invalid Truck ID',
        90103: 'Begining Mileage has invalid value',
        90104: 'Begining Load Time has invalid value',
        90105: 'End Load Time has invalid value',
        90106: 'End Load Time cannot be before Begin Load Time',
        90107: 'Invalid Leave Time',
        90108: 'Leave Time cannot be before End Load Time',
        90109: 'Invalid Driver ID',
        90110: 'Invalid Messenger ID',
        90111: 'Driver ID and Messenger ID cannot be same',
        90112: 'Invalid Route ID',
        90113: 'Route is already Checked Out',
        90114: 'Invalid Truck ID',
        90115: 'Begin Miles has invalid value',
        90116: 'Invalid Driver ID',
        90117: 'Invalid Messenger ID',

        90200: 'Invalid Route ID',
        90201: 'Invalid Vault Date',
        90202: 'Invalid User ID',
        90203: 'Invalid User ID',
        90204: 'Invalid Supervisor ID',
        90205: 'Invalid Window ID',
        90206: 'Invalid Window ID',
        90207: 'Invalid Route ID',
        90208: 'Route is not Checked out',

        90300: 'Invalid Route ID',
        90301: 'Invalid Vault Date',
        90302: 'Invalid GPS latitude',
        90303: 'Invalid GPS latitude',
        90304: 'Invalid GPS longitude',
        90305: 'Invalid GPS longitude',
        90306: 'Invalid Route ID',
        90307: 'Route not Checked Out',

        90400: 'Invalid supervisor ID',

        90500: 'Invalid Messenger ID',
        90501: 'Invalid Vault Date',
        90502: 'Invalid Messenger ID',
        90503: 'Route Messenger ID not found',

        90600: 'Invalid Tracking ID',
        90601: 'Route is not available or not scheduled for Checkin',
        90602: 'Invalid Vault Date',
        90603: 'Invalid User ID',
        90604: 'Invalid Window ID',
        90605: 'Invalid Window ID',
        90606: 'No match found for Shipment ID',
        90607: 'Shipment Already Checked In',
        90608: 'Window not allowed',
        90609: 'Shipment has no delivery location',
        90610: 'Transaction Failed',

        90700: 'Invalid Shipment ID entered',
        90701: 'Invalid Location ID entered',
        90702: 'Invalid Bagout ID entered',
        90703: 'Bagout is already closed',
        90704: "Wrong Destination <br/> {{trackingId}} | Mismatch Destination <br/> Bagout {{bagoutId}}",
        90705: 'Shipment Already Scanned to Bagout',
        90706: 'Max number of shipments are added to Bagout',
        90707: 'From Location Id is not set in Setup record',

        90900: 'Invalid Tracking ID',
        90901: 'Invalid Vault Date',
        90902: 'Route Not Found. Please Retry',
        // 90901: 'This route ID has not been previously checked out',
        90903: 'Invalid Route Selected',
        90904: 'Invalid Window ID',
        90905: 'Item Not Found',
        90906: 'Shipment Already Checked In',
        90907: 'Cash Not Allowed at This Window',
        90908: 'Item Not Delivered',
        90909: 'Coin Not Allowed at This Window',
        90910: 'Route already Checked In',

        901000: "Shipment {{trackingId}} not delivered",
        901001: "Item showing Pickup and Delivery",
        901002: "Item Not Picked up",
        901003: "Item set for pickup, but Delivered",
        901004: "Item not Checked-in (user must exit and scan item)",
        901005: "Item set for Delivery but Picked-up",
        901006: "Item was not Checked out",
        901007: "Location has shipments",
        901008: "Location has no scheduled pickup",
        901009: "No Pickup for Scheduled Location",
        901010: "Location is on Hold",

        91201: "Shipment Not Found",
        91202: "Invalid Shipment ID",
        91203: "Invalid Amount",
        91204: "Amount can't be Negative",
        91205: "Amount can't be zero",
        91206: "Invalid Quantity",
        91207: "Quantity can't be Negative",
        91208: "Quantity can't be zero",

        91101: "Invalid Shipment ID",
        91102: "Invalid Destination Location",

        90612: "Invalid Tanker ID",
        95008: 'Duplicate Tracking ID',

        11000: 'Please select a valid Window'
    },
    window: {
        allowCash: 'Allow Cash',
        allowCoin: 'Allow Coin',
        location: 'Location'
    },
    setup: {
        menu: {
            title: 'Setup',
            all: 'All Setups',
            create: 'Create Setup'
        },
        setups: 'Setups',
        all_setups: 'All Setups',
        create_setup: 'New Setup',
        edit_setup: 'Edit Setup',

        tooltip_delete: 'Delete Setup',
        tooltip_edit: 'Edit Setup',
        tooltip_reload: 'Refresh',

        create_another_title: 'Create Setup',
        create_another_message: 'Do you want to create another Setup?',
        suspend_setup: 'Confirm',
        suspend_setup_message: 'Are you sure you want to Suspend this Setup ?',

        noSetups: 'No Setups Found',

        address: 'Address',

        setupFor: 'setup for',

        state: 'State',
        city: 'City',
        zip: 'Zip',
        telno: 'Telephone Number',
        
        fromLocation: 'Bagout From Location',
        holdRoute: 'Hold Route',
        exitPassword: 'Exit Password',
        confirmExitPassword: 'Confirm Exit Password',
        dataFromServer: 'Data From Server',
        dataToServer: 'Data To Server',
        fromHHTProtocol: 'From HHT Protocol',
        toHHTProtocol: 'To HHT Protocol',
        transmitMsgFiles: 'Transmit Message Files',
        verify: 'Verify',
        prefix: 'Prefix',
        action: 'Actions',
        scannerPrefixes: 'Scanner Prefixes',
        new: 'New',
        type: 'Type', 
        keyVerify: 'Key Verify',
        showCoinTotal: 'Show Coin Total',
        noPrintDelivery: 'No Print Delivery',
        noPrintPickup: 'No Print Pickup',
        coinCheckIn: 'Coin Check In',
        currentVaultDate: 'Current Vault Date',
        imageDirectory: 'Image Directory',
        bagoutManifest: 'Bagout Manifest',
        branch: 'Branch',
        vault: 'Vault',
        language: 'Language',
        exitPasswordMismatch: 'Exit Password and Confirm Exit Password must match',
        directoryPathWarning: 'Make sure that the paths entered above exists',
        maxItemsPerBagout: 'Max. Items Per Bagout',
        new_label: 'New'
    },
    log: {
        menu: {
            title: 'Logs',
            all: 'All Logs'
        },

        tooltip_reload: 'Refresh',
        noLogs: 'No Logs Found',
        extraData: 'Extra Data',
        by: 'by',
        on: 'on',
        key: 'Key',
        value: 'Value',
        supervisors: 'Supervisors',
        users: 'Users',
    },
    connectionStatus: {
        messageConnected: 'You are successfully connected to internet.',
        messageDisconnected: 'You are not connected to internet.',

        refreshNow: 'Refresh Now'
    }
}

export default en;



// WEBPACK FOOTER //
// ./client/app/language/en.js